// extracted by mini-css-extract-plugin
module.exports = {"careerPathSection":"l_L","careerPathHeader":"l_M","imageWrapper":"l_K","cardWrapper":"l_N","info":"l_P","carousel":"l_Q"};